// src/components/chat-header.ts
import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('chat-header')
export class ChatHeader extends LitElement {
    @property({ type: String }) personalityName = ''
    @property({ type: Boolean, reflect: true }) isMobile = false

    private _handleToggle() {
        this.dispatchEvent(
            new CustomEvent('toggle-chat-list', {
                bubbles: true,
                composed: true,
            }),
        )
    }

    render() {
        return html`
            <e-box>
                <e-cluster justify="space-between">
                    <div class="menu-toggle">
                        <icon-button @click="${this._handleToggle}" ariaLabel="Toggle sidebar">
                            <svg viewBox="0 0 24 24">
                                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                            </svg>
                        </icon-button>
                    </div>

                    <e-text textType="heading">${this.personalityName || 'Chat'}</e-text>
                    <settings-button size="medium"></settings-button>
                </e-cluster>
            </e-box>
        `
    }
}
